<template>
    <div ref="viewContainer" id="tags-view-container" class="tags-view-container">
        <ScrollPane ref="scrollPane" class="tags-view-wrapper" :style="{ width: `${this.containerWidth}px` }">
            <router-link
                v-for="tag in visitedViews"
                ref="tag"
                :key="tag.path"
                :class="isActive(tag) ? 'active' : ''"
                :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
                tag="span"
                class="tags-view-item"
                @click.middle.native="!isAffix(tag) ? closeSelectedTag(tag) : ''"
            >
                {{ tag.meta.p_name && tag.meta.p_name + '-' }}{{ tag.meta.title }}
                <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
            </router-link>
        </ScrollPane>
        <el-dropdown trigger="click" style="width: 38px">
            <el-button class="down_icon">
                <font-awesome-icon :icon="['fas', 'angle-double-down']"></font-awesome-icon>
            </el-button>
            <el-dropdown-menu slot="dropdown" class="down_list">
                <el-scrollbar style="height: 300px">
                    <el-dropdown-item v-for="(tag, index) in visitedViews" :key="index">
                        <router-link :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }" tag="div" :class="isActive(tag) ? 'active' : ''"
                            >{{ tag.meta.p_name && tag.meta.p_name + '-' }}{{ tag.meta.title }}</router-link
                        >
                    </el-dropdown-item>
                </el-scrollbar>
                <el-dropdown-item divided><div @click="closeAllTags(selectedTag)">关闭所有</div></el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
import ScrollPane from './ScrollPane.vue'
import path from 'path'
import { mapGetters } from 'vuex'
export default {
    name: `TagsView`,
    components: { ScrollPane },
    data() {
        return {
        // visible: false,
            top: 0,
            left: 0,
            selectedTag: {},
            affixTags: [],
            dropdownvalue: ``,
            envisibletag: []
        }
    },
    computed: {
        ...mapGetters([`visits`, `screenWidth`, `containerWidth`]),
        visitedViews() {
            return this.$store.state.tagsView.visitedViews
        },
        routes() {
            return this.$store.state.routers
        },
        tagItem() {
            const { name, meta, params, path, fullPath, query } = this.$route
            // console.log(this.$route)
            let r = {
                name: name,
                meta: { title: meta.title },
                path: path,
                fullPath: fullPath,
                query: query,
                params: params
            }

            if (params && params.surgeryId > 0) {
                let v = _.find(this.visits, { surgeryId: params.surgeryId })
                r.meta.p_name = ((v && v.name) || `*`)
            }
            return r
        }
        // containerWidth() {
        //   // console.log('resize:', this.screenWidth, 'px')
        //   if (this.$refs.viewContainer == undefined) { return this.screenWidth-320 }
        //   return this.$refs.viewContainer.offsetWidth-40
        // }

    },
    mounted() {
        this.initTags()
        this.addTags()
        this.$nextTick(() => {
            this.$store.commit(`setContainerWidth`, this.$refs.viewContainer.offsetWidth - 40)
        })
    },
    methods: {
        visible() { // 修改为永久显示
            if (this.$refs.scrollPane == undefined) { return false }
            return true
        },
        isActive(route) {
            return route.path === this.$route.path
        },
        isAffix(tag) {
            return tag.meta && tag.meta.affix
        },
        filterAffixTags(routes, basePath = `/`) {
            let tags = []

            routes.forEach(route => {
                if (route.meta && route.meta.affix) {
                    const tagPath = path.resolve(basePath, route.path)
                    tags.push({
                        fullPath: tagPath,
                        path: tagPath,
                        name: route.name,
                        meta: { ...route.meta }
                    })
                }
                if (route.children) {
                    const tempTags = this.filterAffixTags(route.children, route.path)
                    if (tempTags.length >= 1) {
                        tags = [...tags, ...tempTags]
                    }
                }
            })
            return tags
        },
        initTags() {
            const affixTags = this.affixTags = this.filterAffixTags(this.routes)
            for (const tag of affixTags) {
                // Must have tag name
                if (tag.name) {
                    this.$store.dispatch(`tagsView/addVisitedView`, tag)
                }
            }
        },
        addTags() {
            const { name } = this.tagItem
            // 只显示隐藏的
            // const tags = this.$refs.tag
            // if (tags) {

            //  let that = this
            //  let maxlength = this.containerWidth()
            //  let env_tags = _.filter(tags, function (tag) {
            //    return (tag.$el.offsetLeft + tag.$el.offsetWidth) > maxlength
            //  }).map(x => { return x.to.path })
            //  this.envisibletag = _.filter(this.visitedViews, function (v) {
            //    return _.findIndex(env_tags, function (t) {
            //      return t == v.path
            //    }) > -1
            //  })

            // }

            if (name && name != `index` && name != `surgery`) {
                this.$store.dispatch(`tagsView/addView`, this.tagItem)
            }
            return false
        },
        moveToCurrentTag() {
            const tags = this.$refs.tag
            if (!tags) return
            this.$nextTick(() => {
                for (const tag of tags) {
                    if (tag.to.path === this.$route.path) {
                        this.$refs.scrollPane.moveToTarget(tag)
                        // when query is different then update
                        if (tag.to.fullPath !== this.$route.fullPath) {
                            this.$store.dispatch(`tagsView/updateVisitedView`, this.tagItem)
                        }
                        break
                    }
                }
            })
        },
        refreshSelectedTag(view) {
            this.$store.dispatch(`tagsView/delCachedView`, view).then(() => {
                const { fullPath } = view
                this.$nextTick(() => {
                    this.$router.replace({
                        path: `/redirect` + fullPath
                    })
                })
            })
        },
        closeSelectedTag(view) {
            this.$store.dispatch(`tagsView/delView`, view).then(({ visitedViews }) => {
                if (this.isActive(view)) {
                    this.toLastView(visitedViews, view)
                }
            })
        },
        closeOthersTags() {
            this.$router.push(this.selectedTag)
            this.$store.dispatch(`tagsView/delOthersViews`, this.selectedTag).then(() => {
                this.moveToCurrentTag()
            })
        },
        closeAllTags(view) {
            this.$store.dispatch(`tagsView/delAllViews`).then(({ visitedViews }) => {
                if (this.affixTags.some(tag => tag.path === view.path)) {
                    return
                }
                this.toLastView(visitedViews, view)
            })
        },
        toLastView(visitedViews, view) {
            const latestView = visitedViews.slice(-1)[0]
            if (latestView) {
                this.$router.push(latestView.fullPath)
            } else {
                // now the default is to redirect to the home page if there is no tags-view,
                // you can adjust it according to your needs.
                // if (view.name === 'portal') {
                // } else {
                //   this.$router.push('/')
                // }
                this.$router.push(`/`)
            }
        },
        openMenu(tag, e) {
            const menuMinWidth = 105
            const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
            const offsetWidth = this.$el.offsetWidth // container width
            console.log(offsetWidth)
            console.log(this.screenWidth - 240)
            const maxLeft = offsetWidth - menuMinWidth // left boundary
            const left = e.clientX - offsetLeft + 15 // 15: margin right

            if (left > maxLeft) {
                this.left = maxLeft
            } else {
                this.left = left
            }

            this.top = e.clientY
            this.visible = true
            this.selectedTag = tag
        },
        closeMenu() {
            this.visible = false
        }
    },
    watch: {
        screenWidth() {
            this.$store.commit(`setContainerWidth`, this.$refs.viewContainer.offsetWidth - 40)
        },
        $route() {
            this.addTags()
            this.moveToCurrentTag()
        }
    }
}
</script>

<style scoped lang="less">
.el-dropdown {
    height: 100%;
}
.down_list {
    .active {
        color: var(--primary-color, #009688);
        /*&::before

  {
    content: '';
    background: #fff;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    position: relative;
    margin-right: 2px;
  }*/
    }
}

.tags-view-container {
    height: 34px;
    width: 100%;
    background: #fff;
    border-bottom: 1px solid #d8dce5;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
    .down_icon {
        width: 98%;
        height: 100%;
        border-top: none;
        border-bottom: none;
        border-right: none;
        border-radius: unset;
        background: inherit;
    }
    .tags-view-wrapper {
        height: 100%;
        float: left;
        .tags-view-item {
            display: inline-block;
            position: relative;
            cursor: pointer;
            height: 30px;
            line-height: 28px;
            border: 1px solid #d8dce5;
            color: #495060;
            background: #fff;
            padding: 0 8px;
            font-size: 14px;
            margin-left: 6px;
            margin-top: 2px;
            &:first-of-type {
                margin-left: 14px;
            }

            &:last-of-type {
                margin-right: 15px;
            }

            &.active {
                background-color: #42b983;
                color: #fff;
                border-color: #42b983;
                &::before {
                    content: '';
                    background: #fff;
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    position: relative;
                    margin-right: 2px;
                }
            }
        }
    }

    .contextmenu {
        margin: 0;
        background: #fff;
        z-index: 3000;
        position: absolute;
        list-style-type: none;
        padding: 5px 0;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 400;
        color: #333;
        box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
        li {
            margin: 0;
            padding: 7px 16px;
            cursor: pointer;
            &:hover {
                background: #eee;
            }
        }
    }
}
</style>

<style lang="less">
.tags-view-wrapper {
    .tags-view-item {
        .el-icon-close {
            width: 20px;
            height: 20px;
            vertical-align: 2px;
            border-radius: 50%;
            text-align: center;
            transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
            transform-origin: 100% 50%;
            &:before {
                transform: scale(0.6);
                display: inline-block;
                vertical-align: -3px;
            }

            &:hover {
                background-color: #b4bccc;
                color: #fff;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/common/TagsView.vue